import React, { useState } from 'react';
import './ActTable.css';

const ActTable = ({
    orders,
    dateDelivery,
    doctorName,
    pacient,
    companyName,
    onBack,
    data
}) => {
    const formattedDate = new Date().toLocaleDateString();

    // Общая сумма
    const totalPrice = orders
        .reduce((sum, o) => sum + (parseFloat(o.price) || 0), 0)
        .toFixed(2);

    const [description, setDescription] = useState('Изготовление коронок');

    // Номер первого заказа
    const firstOrderNumber = orders.length > 0 ? orders[0].number || orders[0].id : '—';

    // Печать
    const handlePrint = () => {
        const html = generateHtml(
            data,
            orders,
            dateDelivery,
            doctorName,
            pacient,
            companyName,
            description
        );
        
        const printWindow = window.open('', '_blank');
        printWindow.document.write(html);
        printWindow.document.close();
        printWindow.print();
    };

    // Скачать PDF
    const handleDownload = () => {
        const html = generateHtml(
            data,
            orders,
            dateDelivery,
            doctorName,
            pacient,
            companyName,
            description
        );
        
        const blob = new Blob([html], { type: 'text/html' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `act_${firstOrderNumber}_${formattedDate.replace(/\./g, '_')}.html`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    };

    return (
        <div className="act-table-container">
            {/* Верхние кнопки */}
            <div className="act-table-header-buttons">
                <button onClick={onBack} className="act-table-button">
                    Назад
                </button>
                <button onClick={handlePrint} className="act-table-button">
                    Печать
                </button>
                <button onClick={handleDownload} className="act-table-button">
                    Скачать
                </button>
            </div>

            {/* Прокручиваемая часть */}
            <div className="act-table-content">
                <h1 className="act-table-title">
                    Акт № {firstOrderNumber} от {formattedDate}
                </h1>
                <h4 className="act-table-subtitle">Исполнитель: {companyName}</h4>
                <h4 className="act-table-subtitle">Заказчик: {doctorName || 'Не указан'}</h4>
                <h4 className="act-table-subtitle">Пациент: {pacient || 'Не указан'}</h4>

                {/* Таблица */}
                <div className="act-table-table">
                    <div className="act-table-row act-table-header-row">
                        {data?.headers?.map((header, i) => (
                            <div
                                key={i}
                                className={`act-table-cell act-table-header-cell ${i === 2 ? 'act-table-cell-wide' : ''} ${i === 3 ? 'act-table-cell-price' : ''}`}
                            >
                                {header}
                            </div>
                        ))}
                    </div>

                    {orders.map((o, i) => (
                        <div key={o.id || i} className="act-table-row">
                            <div className="act-table-cell">{i + 1}</div>
                            <div className="act-table-cell">{o.number || o.id}</div>
                            <div className="act-table-cell act-table-cell-wide">
                                <input
                                    type="text"
                                    className="act-table-input"
                                    value={o.pacient || description}
                                    onChange={(e) => setDescription(e.target.value)}
                                />
                            </div>
                            <div className="act-table-cell act-table-cell-price">{o.price || '0.00'}</div>
                        </div>
                    ))}

                    {/* Строка "Итого" */}
                    <div className="act-table-row act-table-total-row">
                        <div className="act-table-cell"></div>
                        <div className="act-table-cell"></div>
                        <div className="act-table-cell act-table-cell-wide act-table-total-label">
                            Итого:
                        </div>
                        <div className="act-table-cell act-table-cell-price act-table-total-value">{totalPrice}</div>
                    </div>
                </div>

                {/* Итоговый блок */}
                <div className="act-table-summary">
                    <p className="act-table-bold">Итого: {totalPrice} руб</p>
                    <p>
                        Всего оказано услуг: {orders.length}, на сумму {totalPrice} руб
                    </p>
                    <p className="act-table-info">
                        Вышеперечисленные услуги (работы, товары) выполнены (поставлены)
                        полностью в срок. Качество выполненных работ проверено Заказчиком и
                        соответствует его требованиям. Заказчик претензий по объему, качеству и
                        срокам оказания услуг не имеет.
                    </p>
                </div>

                {/* Подписи */}
                <div className="act-table-line" />

                <div className="act-table-signatures">
                    <div className="act-table-signature-block">
                        <p>ИСПОЛНИТЕЛЬ</p>
                        <p>{companyName}</p>
                        <div className="act-table-signature-line" />
                        <p>Подпись</p>
                    </div>
                    <div className="act-table-signature-block">
                        <p>ЗАКАЗЧИК</p>
                        <p>{doctorName || 'Не указан'}</p>
                        <div className="act-table-signature-line" />
                        <p>Подпись</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

// Функция генерации HTML
const generateHtml = (
    data,
    orders,
    dateDelivery,
    doctorName,
    pacient,
    companyName,
    description
) => {
    const formattedDate = new Date().toLocaleDateString();
    const totalPrice = orders.reduce((sum, o) => sum + (parseFloat(o.price) || 0), 0).toFixed(2);

    const tableHeaders = data?.headers?.map(header => `<th>${header}</th>`).join("") || "";

    const tableRows = orders
        .map(
            (o, i) => `
            <tr>
                <td>${i + 1}</td>
                <td>${o.number || o.id || "—"}</td>
                <td>${o.pacient || description || "—"}</td>
                <td>${o.price || "0.00"}</td>
            </tr>
        `
        )
        .join("");

    return `
    <!DOCTYPE html>
    <html>
    <head>
        <meta charset="utf-8" />
        <title>Акт</title>
        <style>
            body {
                margin: 40px;
                font-family: Arial, sans-serif;
                font-size: 14px;
                color: #000;
            }
            h1 {
                text-align: center;
                margin-bottom: 20px;
            }
            h4 {
                margin: 5px 0;
            }
            table {
                width: 100%;
                border-collapse: collapse;
                margin-top: 20px;
            }
            th, td {
                border: 1px solid #555;
                padding: 6px 8px;
                text-align: left;
                vertical-align: top;
            }
            th {
                background-color: #f4f4f4;
                text-align: center;
            }
            .summary {
                margin-top: 20px;
                line-height: 1.5;
            }
            .bold {
                font-weight: bold;
            }
            .line {
                width: 100%;
                border-top: 2px solid #000;
                margin: 25px 0;
            }
            .signatures {
                display: flex;
                justify-content: space-between;
                margin-top: 40px;
            }
            .signatureBlock {
                width: 45%;
                text-align: center;
            }
            .signatureLine {
                border-top: 1px solid #000;
                margin: 30px 0 5px;
            }
            .info {
                margin-top: 10px;
                font-size: 12px;
                text-align: justify;
            }
        </style>
    </head>
    <body>
        <h1>Акт № ${orders.map(o => o.number || o.id).join(", ")} от ${formattedDate}</h1>

        <h4>Исполнитель: ${companyName}</h4>
        <h4>Заказчик: ${doctorName || "Не указан"}</h4>
        <h4>Пациент: ${pacient || "Не указан"}</h4>

        <table>
            <tr>${tableHeaders}</tr>
            ${tableRows}
        </table>

        <div class="summary">
            <p class="bold">Итого: ${totalPrice} руб.</p>
            <p>Всего оказано услуг: ${orders.length}, на сумму ${totalPrice} руб.</p>
            <p class="info">
                Вышеперечисленные услуги (работы, товары) выполнены (поставлены) полностью в срок.
                Качество выполненных работ проверено Заказчиком и соответствует его требованиям.
                Заказчик претензий по объему, качеству и срокам оказания услуг не имеет.
            </p>
        </div>

        <div class="line"></div>

        <div class="signatures">
            <div class="signatureBlock">
                <p>ИСПОЛНИТЕЛЬ</p>
                <p>${companyName}</p>
                <div class="signatureLine"></div>
                <p>Подпись</p>
            </div>
            <div class="signatureBlock">
                <p>ЗАКАЗЧИК</p>
                <p>${doctorName || "Не указан"}</p>
                <div class="signatureLine"></div>
                <p>Подпись</p>
            </div>
        </div>

        <div style="display:none">${Date.now()}</div>
    </body>
    </html>
    `;
};

export default ActTable;

